"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const slider = document.querySelector(".o-diferenciais__cards.splide");

        if (!slider) return;

        const splide = new Splide(slider, {
            type: "loop",
            perPage: 3,
            autoplay: false,
            interval: 5000,
            speed: 800,
            drag: false,
            arrows: false,
            pagination: false,
            pauseOnHover: true,
            gap: "1.75rem",
            breakpoints: {
                1024: {
                    perPage: 2,
                    drag: true,
                    autoplay: true,
                    arrows: true,
                },
                680: {
                    perPage: 1,
                },
            },
        });
        const bar = splide.root.querySelector(".my-slider-progress-bar");
        splide.on("mounted move", function () {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min((splide.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
        });

        splide.mount();
    });
}
